import * as Yup from 'yup'

export const SkillsValidationSchema = Yup.object().shape({
  alfabetizado: Yup.object().shape({
    status: Yup.string(),
  }),
  primaria: Yup.object().shape({
    status: Yup.string(),
    institucion: Yup.string().optional(),
  }),
  secundaria: Yup.object().shape({
    status: Yup.string(),
    institucion: Yup.string().optional(),
  }),
  terciaria: Yup.object().shape({
    status: Yup.string(),
    institucion: Yup.string().optional(),
    career: Yup.string().when('status', {
      is: (status: string) => !!status,
      then: (value) => value.required('Se requiere la Carrera Técnica y/o Universitaria'),
    }),
  }),
  posGraduacion: Yup.object().shape({
    status: Yup.string(),
    institucion: Yup.string().optional(),
  }),
  mestrado: Yup.object().shape({
    status: Yup.string(),
    institucion: Yup.string().optional(),
  }),
  doctorado: Yup.object().shape({
    status: Yup.string(),
    institucion: Yup.string().optional(),
  }),
  personalSkills: Yup.string().optional(),
  activitiesPerformed: Yup.string().optional(),
  completedCourses: Yup.array().of(Yup.string()).max(10, 'Solo se permiten 10 cursos'),
  languages: Yup.array().of(Yup.string()),
  skills: Yup.array().of(Yup.string())
})
